import React from "react";
import logo from "../../assets/logo/logo_214x214.png"
const mindalaySvg = (props) => {
  return <img src={logo} alt="/" height={props.height}/>;
}

export default mindalaySvg;